module.exports = __webpack_public_path__ + "src/static/quick-start-guide.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/static/quick-start-guide.pdf
// module id = 602
// module chunks = 0